// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetFlatAreasDesktopRequest,
  TGetFlatAreasDesktopModel,
  IMappers,
  TGetFlatAreasDesktopResponse,
  IGetFlatAreasDesktopResponse,
  IGetFlatAreasDesktopResponseError,
} from './types';

export const defaultConfig: TGetFlatAreasDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-flat-areas-desktop/',
} as TGetFlatAreasDesktopModel;

export function createGetFlatAreasDesktopModel(parameters: IGetFlatAreasDesktopRequest): TGetFlatAreasDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetFlatAreasDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetFlatAreasDesktopRequest;
}

export async function fetchGetFlatAreasDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetFlatAreasDesktopOptions<TResponse200, TResponse400>): Promise<
  TGetFlatAreasDesktopResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetFlatAreasDesktopModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFlatAreasDesktopResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetFlatAreasDesktopResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetFlatAreasDesktopResponse;
}
